/* eslint-disable @typescript-eslint/no-explicit-any */
import './login.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/app/hooks';
import { setIsGuest } from '@/features/spotifyAuth/authSlice';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { auth, signInWithGoogle } from '@/services/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useEffect } from 'react';
import { useAuthStore } from '@/zustand/useAuthGoogle';
import { Spinner } from '@/components/atoms/Spinner';

export const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { from } = location.state || ({ from: { pathname: '/' } } as any);
  const { t } = useTranslation();
  const [user, loading] = useAuthState(auth);
  const addUser = useAuthStore((state) => state.setUser);

  const loginGuest = () => {
    dispatch(setIsGuest(true));
    navigate(from.pathname);
  };

  useEffect(() => {
    if (!user) return;
    addUser(user);
    navigate(from.pathname);
    dispatch(setIsGuest(true));
  }, [addUser, dispatch, from.pathname, navigate, user]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <main className='p-login'>
      <section className='p-login__header'>
        {/* <SpotifyIcon width='100' height='100' /> */}
        <h1 className='p-login__title'>{t('login.title')}</h1>
      </section>
      <motion.button
        className='p-login__spotify'
        whileTap={{ scale: 0.99 }}
        animate={{ scale: 1 }}
        onClick={() => signInWithGoogle()}>
        {t('login.google')}
      </motion.button>
      <motion.button
        className='p-login__guest'
        whileTap={{ scale: 0.99 }}
        animate={{ scale: 1 }}
        onClick={() => loginGuest()}>
        {t('login.guest')}
      </motion.button>
    </main>
  );
};
